import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-38194a70")

_pushScopeId("data-v-38194a70")
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_backdrop = _resolveComponent("ion-backdrop")
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_orders_table = _resolveComponent("orders-table")
  const _component_ion_content = _resolveComponent("ion-content")

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_ion_backdrop, {
          ref: "overlay",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('search-toggle', false)))
        }, null, 512),
        _createVNode("section", {
          ref: "modalWrapper",
          onKeyupCapture: _cache[5] || (_cache[5] = _withKeys($event => (_ctx.$emit('search-toggle', false)), ["esc"])),
          class: "modal-wrapper ion-overlay-wrapper"
        }, [
          _createVNode("header", _hoisted_2, [
            _createVNode(_component_ion_searchbar, {
              "show-cancel-button": "focus",
              animated: "",
              placeholder: "Search by order# or customer Name",
              onIonChange: _cache[2] || (_cache[2] = $event => (_ctx.updateResults($event)))
            }),
            _createVNode(_component_ion_button, {
              size: "small",
              fill: "transparent",
              class: "btn-close",
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('search-toggle', false)))
            }, {
              default: _withId(() => [
                _createVNode(_component_ion_icon, { icon: "/assets/icons/close.svg" })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_ion_content, { "scroll-y": true }, {
            default: _withId(() => [
              (_ctx.orders)
                ? (_openBlock(), _createBlock(_component_orders_table, {
                    key: 0,
                    title: "Orders",
                    orders: _ctx.orders,
                    "onOrder-clicked": _cache[4] || (_cache[4] = $event => (_ctx.$emit('search-toggle', false)))
                  }, null, 8, ["orders"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 544)
      ])
    ]),
    _: 1
  }))
})